module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pie-wrap"
  }, [_c('div', {
    ref: "pieBg",
    staticClass: "pie-bg"
  }, [_c('div', {
    staticClass: "percentage-box"
  }, [_c('span', {
    staticClass: "num"
  }, [_c('bs-numbers', {
    attrs: {
      "count": _vm.percentage,
      "suffix": "%",
      "decimal": "2"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("成功率")])])]), _vm._v(" "), _c('audio', {
    ref: "audio",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "src": _vm.bgAudioUrl
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4a6250a7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/pie/index.vue
// module id = 234
// module chunks = 0